import { useEffect } from "react";
import { useRedirect } from "react-admin";
import { TEXTILES } from "@/config/resources";

export const TextilesList = () => {
  const redirect = useRedirect();

  useEffect(() => {
    redirect(`/${TEXTILES}`);
  }, [redirect]);

  return null;
};

